import { fetchAuthSession } from 'aws-amplify/auth';
import type { Lead, LeadEvent, LeadStatus } from '@embrace-returns/shared';

const BASE = import.meta.env.VITE_API_URL;

async function authHeader(): Promise<Record<string, string>> {
  const session = await fetchAuthSession();
  const token = session.tokens?.idToken?.toString();
  return token ? { Authorization: token } : {};
}

async function request<T>(path: string, init: RequestInit = {}): Promise<T> {
  const headers = {
    'Content-Type': 'application/json',
    ...(await authHeader()),
    ...(init.headers ?? {}),
  };
  const res = await fetch(`${BASE}${path}`, { ...init, headers });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(`${res.status} ${text}`);
  }
  return res.json() as Promise<T>;
}

export const api = {
  leads: {
    list: (status: LeadStatus = 'New') =>
      request<{ leads: Lead[] }>(`/leads?status=${encodeURIComponent(status)}`),
    get: (leadId: string) =>
      request<{ lead: Lead; events: LeadEvent[] }>(
        `/leads/${encodeURIComponent(leadId)}`,
      ),
    close: (
      leadId: string,
      body: {
        notify: 'referrer' | 'other' | 'none';
        recipientEmail?: string;
      } = { notify: 'none' },
    ) =>
      request<{
        leadId: string;
        status: LeadStatus;
        closedAt?: string;
        notified?: boolean;
        emailFailed?: boolean;
      }>(`/leads/${encodeURIComponent(leadId)}/close`, {
        method: 'POST',
        body: JSON.stringify(body),
      }),
  },
};
